import React from "react";
import { cn } from "../../../../../../utils/classnames";

const VehicleCell = ({ vehicleType = "-", vehicleClass = "Vehicle", vehicleImage = "-", bold, note }) => (
  <div className="tw:flex tw:flex-col tw:lg:flex-row tw:items-start tw:lg:items-center tw:justify-between tw:w-full tw:gap-4 tw:lg:gap-0">
    <div className="tw:flex tw:flex-col tw:gap-1.5 tw:w-full tw:lg:w-[307px]">
      <div className="tw:text-[#8d8d8d] tw:text-[8px] tw:leading-[12px] tw:tracking-[3px] tw:uppercase tw:font-semibold tw:font-hanken-grotesk">
        {vehicleClass}
      </div>
      <div className={cn(
        "tw:text-[#282828] tw:text-[15px] tw:leading-[22px] tw:font-hanken-grotesk",
        bold ? "tw:font-bold" : "tw:font-normal"
      )}>
        {vehicleType}
      </div>
      {note && (
        <p className="tw:!m-0 tw:!text-[12px] tw:!font-[400] tw:!text-[#8D8D8D]">
          {note}
        </p>
      )}
    </div>
    <img src={vehicleImage} alt={vehicleType} className="tw:w-full tw:lg:w-[165px] tw:h-[88px] tw:object-contain tw:rounded-[5px] tw:lg:rounded-none" />
  </div>
);

export default VehicleCell;
